<template>
   <div class="col-md-12">
       <h5>{{ mixedStep.title }}</h5>
        <div class="row">
            <template v-for="(item, index) in sortedItems">
            <div class="col-md-6 col-lg-4" v-if="item.title"
            :class="[ item.specificationPropertyMasterDataId == mixedStep.selected ? 'active' : '', xlclass]" :key = "index">
                <div class="solution-spec">
                    <div>
                        <div v-if="hasNoImage(item.specificationPropertyMasterDataId)">
                            <div style="color:#000000; font-family: trim-medium; font-size:22px; padding: 15px 25px;" @click="selectSpecification(item.specificationPropertyMasterDataId, item.title)" class="pointer no-image">
                                {{ item.title }}
                                <hr>
                            </div>
                        </div>
                        <div v-else>
                            <div class="product-image">
                                <img :src="item.image" alt style="width:100%;" @click="selectSpecification(item.specificationPropertyMasterDataId, item.title)" class="pointer"/>
                            </div>
                            <div style="color:#000000; font-family: trim-medium; font-size:22px; padding: 15px 25px;" @click="selectSpecification(item.specificationPropertyMasterDataId, item.title)" class="pointer">
                                {{ item.title }}
                                <hr>
                            </div>
                        </div>
                    </div>
                    <div class="product-details">
                        <div v-for="feature in getText(item.specificationPropertyMasterDataId)" :key="feature.id" style="font-size:14px; padding-top:10px; padding-bottom:10px;">
                            <span v-if="['Yes', 'No'].indexOf(feature.value) == -1">
                            {{ feature.value }}
                            </span>
                        </div>
                        <div v-for="feature in getColour(item.specificationPropertyMasterDataId)" :key="feature.id">
                            <span v-if="['Yes', 'No'].indexOf(feature.value) == -1"
                                :style="{backgroundColor:'#'+feature.value}" class="colour"
                                ></span>
                        </div>

                        <div v-for="feature in getFeatures(item.specificationPropertyMasterDataId)" :key="feature.id">
                            <span v-if="['Yes', 'No'].indexOf(feature.value) == -1" style="margin: 10px 0">
                                <i v-if="feature.key != 'label'" :class="'icon icon-' + slugify(feature.value)"></i> {{ feature.value }}
                            </span>
                        </div>
                        <br />
                        <br />
                        <div class="button">
                            <button @click="selectSpecification(item.specificationPropertyMasterDataId, item.title)" class="btn btn-hover btn-wishlist"
                            :class="{ 'btn-green-full': item.specificationPropertyMasterDataId == mixedStep.selected, 'btn-orange-full': item.specificationPropertyMasterDataId != mixedStep.selected }"
                            >
                            {{ item.specificationPropertyMasterDataId == mixedStep.selected ? 'SELECTED' : 'SELECT'}}
                            </button>
                        </div>
                    </div>
                </div>
                </div>
            </template>

        </div>
    </div>
</template>

<script>
export default {
    name: "solution-specs",
    props: {
        mixedStep : Object,
        features : Array,
        label_na_for_your_vehicle: {
            type: String,
            required: true,
            default: "Not available for your vehicle"
        },
        label_bar_style: {
            type: String,
            default: "Bar Style"
        },
        label_colour: {
            type: String,
            default: "Colour"
        },

    },
    mounted() {
        if ((this.mixedStep.items && this.mixedStep.items.length === 0) || this.mixedStep.items.every((item) => item.title === "")) {
            this.$emit('skipStep', this.mixedStep.specificationId);
        }
    },
    methods: {
        selectSpecification(categoryId, categoryTitle) {
            ga('send','event', 'Fit My Vehicle', this.mixedStep.title +  ' Spec', categoryTitle);
            gtag('event', 'fit_my_vehicle_solution_specs', {'category':'Fit My Vehicle', 'action':this.mixedStep.title +  ' Spec', value:categoryTitle});
            this.mixedStep.selected = categoryId;
            this.$emit("selectSpecification", categoryId);
        },
        slugify(string) {
            const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
            const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
            const p = new RegExp(a.split('').join('|'), 'g')

            return string.toString().toLowerCase()
                .replace(/\s+/g, '-') // Replace spaces with -
                .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
                .replace(/&/g, '-and-') // Replace & with 'and'
                .replace(/[^\w\-]+/g, '') // Remove all non-word characters
                .replace(/\-\-+/g, '-') // Replace multiple - with single -
                .replace(/^-+/, '') // Trim - from start of text
                .replace(/-+$/, '') // Trim - from end of text
        },
        getFeatures(specificationPropertyMasterDataId){
            return this.features.filter(item => ((item.specificationPropertyMasterDataId == specificationPropertyMasterDataId) && (item.key != 'text') && (item.key != 'colour')));
        },
        getText(specificationPropertyMasterDataId){
            return this.features.filter(item => ((item.specificationPropertyMasterDataId == specificationPropertyMasterDataId) && (item.key == 'text')));
        },
        getColour(specificationPropertyMasterDataId){
            return this.features.filter(item => ((item.specificationPropertyMasterDataId == specificationPropertyMasterDataId) && (item.key == 'colour')));
        },
        hasNoImage(id) {
            let noImageList = [
                '97F3F927-0B65-4B95-9A44-687832E5FAF9',
                '41C92E0C-600F-4617-90A8-558AC39376F6',
                'E534853E-4E2F-4D86-9A0F-09ACF7D03E0E',
                'E043A727-2A85-4094-B500-FBCC64065FAE'
            ];
            return noImageList.includes(id);
        }
    },
    computed: {
    xlclass() {

        let val = 12 / this.mixedStep.items.length;
        val = val >= 6 ? 6 : val;
        return 'col-xl-'+val;

    },
    sortedItems() {
        return this.mixedStep.items.sort((a,b) => a.title.localeCompare(b.title));
    }
  },
};
</script>
<style scoped>
.pointer.no-image {
    display: flex;
    justify-content: center;
    align-items: center;
}

.solution-spec {
    padding: 0;
    background-color: #f8f8f8;
}

.product-details {
    padding: 5px 25px 25px 25px;
}

.product-image {
    border-bottom: 1px solid #b3b3b3;
}

.btn-orange-full,
.btn-green-full {
    padding: 5px 0;
}
</style>
